import { render, staticRenderFns } from "./NewLeaveRequest.vue?vue&type=template&id=a47fda0a&"
import script from "./NewLeaveRequest.vue?vue&type=script&lang=js&"
export * from "./NewLeaveRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a47fda0a')) {
      api.createRecord('a47fda0a', component.options)
    } else {
      api.reload('a47fda0a', component.options)
    }
    module.hot.accept("./NewLeaveRequest.vue?vue&type=template&id=a47fda0a&", function () {
      api.rerender('a47fda0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/LeaveManagement/NewLeaveRequest.vue"
export default component.exports